<template>
<div class="container-fluid" > 

<!-- Modal -->
<div class="modal" id="staticBackdrop_PieChart" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header ">
        <h5 class="modal-title" id="staticBackdropLabel">
            <i class="fas fa-chart-pie mr-2"></i>
            GRAFICO VENDITE</h5>
       
      </div>
      <div class="modal-body">

        <div v-if="spinner" class="d-flex justify-content-center">
            <div class="spinner-border spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
       
        <div v-else>
            <GChart :type="type" :data="chartData" :options="chartOptions" />
        </div>

      </div>
      <div class="modal-footer">
        <button @click="closeModal()" type="button" class="btn btn-primary" >CHIUDI</button>
        
      </div>
    </div>
  </div>
</div>


</div>
</template>

<script>
//import api               from "@/api";
import { mapGetters }    from 'vuex';
import { GChart }        from "vue-google-charts";
import fmt               from '@/components/mixins/fmt'
export default {
    mixins     : [fmt],
    props      : ['data'],
  components: {
    GChart
  },
  data() {
    return {


       type             : 'PieChart',
       chartData        : [],
       chartOptions     : {},
       spinner          : false
       
    }


  },

computed :{
    ...mapGetters(['company']),},

mounted: function() {
    this.setData()
    

},
created: function() {
   
    this.$nextTick(()  => {
        $('#staticBackdrop_PieChart').modal('show')               
    
    })

    console.log(this.data)
  },
 methods: 
  {
    closeModal()
    {
      $('#staticBackdrop_PieChart').modal('hide')
      this.$nextTick(()  => {              
        this.$emit('close')        
      })    
    },   
     setData()
     {
        const chartData = []
        let total = 0
        chartData.push(['Provenienza','Totale'])
                
                         
        this.data.forEach(item => {
            if(item.totalSold > 0)
            {
              const itemData  = [item.mp,item.totalSold]
              total += item.totalSold
              chartData.push(itemData)   
            }
            
        })  
              
             
              
              
              this.chartData = chartData
              this.chartOptions.title = "VENDITE PER UNITA'"
              // + this.fmt1(total) 
              this.chartOptions.width = 1000
              this.chartOptions.height = 700

             
     },   
    
   
  }

};
</script>
<style scoped>
.modal-header{
    background-color : rgb(193, 193, 126);
    color            : black ;
}

</style>
